export type TbnrPreset = { tbnr: string; label: string; hint: string };

export const TBNR_PRESETS: TbnrPreset[] = [
  { tbnr: "112263", label: "Einmündung <5 mB", hint: "< 5 m vor Kreuzung/Einmündung, mit Behinderung — 15 €" },
  { tbnr: "112265", label: "Einmündung <5 mB >3h", hint: "< 5 m vor Kreuzung/Einmündung, > 3 h, mit Behinderung — 30 €" },
  { tbnr: "112454", label: "Gehweg", hint: "Parken auf Gehweg — 55 €" },
  { tbnr: "112656", label: "Gehweg > 1h", hint: "Parken auf Gehweg > 1 h — 70 €" },
  { tbnr: "112655", label: "Gehweg mB", hint: "Parken auf Gehweg mit Behinderung — 70 €" },
  { tbnr: "112657", label: "Gehweg > 1h mB", hint: "Parken auf Gehweg > 1 h, mit Behinderung — 80 €" },
];

export const DEFAULT_TBNR = "112265";
